import React, { Component, lazy, Suspense } from "react";
import { connect } from "react-redux";
import "./Contact.css";
import { topNavOption } from "../../action/actions";
import Header from "../LandingPage/Header/Header";
import loadingImg from "../../assets/loadingImg.png";
import Footer from "../LandingPage/Footer/Footer";

const Section1 = lazy(() => import("./Section1/Section1"));
const Section2 = lazy(() => import("./Section2/Section2"));
const Section3 = lazy(() => import("./Section3/Section3"));
const Section4 = lazy(() => import("./Section4/Section4"));

class Contact extends Component {
  componentDidMount = () => {
    window.scrollTo(0, 0);
    this.props.topNavOption("Partner");
  };
  render() {
    return (
      <div style={{ background: "#FBFBFD" }}>
        <Suspense
          fallback={
            <div className="loader-screen">
              <img className="App-logo" src={loadingImg} alt="logo" />
            </div>
          }
        >
          <Header />
          <Section1 />
          <Section2 />
          <Section3 />
          <Section4 />
          <div className="white-space">
            <p>
              Interested in partnering with us and bringing the benefits of Cup
              O’ Sugar to your property, email us{" "}
              <a href="mailto:admin@cuposugarapp.com">here</a>.
            </p>
          </div>
          <Footer />
        </Suspense>
      </div>
    );
  }
}

export default connect(null, { topNavOption })(Contact);
